/* eslint-disable import/no-unresolved */
import { trackEventGA4 } from '@usafacts/frontend-library-utils/googleAnalytics';
import $ from 'cash-dom';
import Cookies from 'js-cookie';
const COOKIE_TRUE = '1';
const COOKIE_DAYS = 7;
export default function () {
  $(document).on('click', `#newsletter__submit`, trackEventGA4('Submit-Test-CMS', 'Newsletter', 'cms'));
  $(document).on('click', `#newsletter__covid__recovery__hub__submit`, trackEventGA4('Submit-Test-CMS', 'Newsletter', 'cms'));
  $(document).on('click', `newsletter__block__submit`, trackEventGA4('Submit-Test-CMS', 'Newsletter', 'cms'));
  $(document).on('click', `#newsletter__content_block__submit`, trackEventGA4('Submit-Test-CMS', 'Newsletter', 'cms'));
  $(document).on('click', `#newsletter__base__submit`, trackEventGA4('Submit-Test-CMS', 'Newsletter', 'cms'));
  $(document).on('click', `#newsletter__small__submit`, trackEventGA4('Submit-Test-CMS', 'Newsletter', 'cms'));
  $(document).on('click', `#newsletter_small_block__submit`, trackEventGA4('Submit-Test-CMS', 'Newsletter', 'cms'));
  const newsletterHidden = Cookies.get('newsletterHidden');
  function removeNewsletter() {
    $('#newsletter__sticky').remove();
  }
  if (newsletterHidden === COOKIE_TRUE) {
    removeNewsletter();
  } else {
    setTimeout(() => {
      $('#newsletter__sticky').removeClass('hidden');
    }, 10000);
    $('.js-newsletter--close').on('click', e => {
      e.preventDefault();
      removeNewsletter();
      Cookies.set('newsletterHidden', COOKIE_TRUE, {
        expires: COOKIE_DAYS
      });
    });
    $('.js-newsletter--expand').on('click', () => {
      $('#newsletter__grid__content').toggleClass('hidden');
    });
  }
}